import { useContext } from 'react';
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';
import Upload from '../upload/Upload';
import { QuestionsContext } from '../../context/Questions';
import HttpAxios from '../../hooks/http';
import { IMenuItem, IFormatQuestion } from '../../interfaces/items';
import { EQuestion, ESelectCustom, ESelectTheme } from '../../statics/controls';
import IconDownload from '../../../images/download.svg';
import IconInfo from '../../../images/info.svg';
import './wizard.scss';

interface IWizard {
    questions: any;
}

const Wizard = ({ questions }: IWizard) => {
    const { selectedMenu } = useContext(QuestionsContext);
    const selectStyles = ESelectCustom;
    const selectTheme = ESelectTheme;
    const { register, formState, setError, reset, watch } = useForm({
        mode: 'onChange',
    });
    const { errors } = formState;
    const createName = (idQuestion: string, idSection: string) => {
        return 'q' + idQuestion + '-' + idSection;
    };

    const saveQuestion = (answer: any, nameField: string, type: number) => {
        HttpAxios.post('forms/save_question', answer)
            .then((res: any) => {
                const { err } = res?.data || {};
                if (err) {
                    // error in save
                    nameField &&
                        setError(nameField, {
                            type: 'manual',
                            message: err,
                        });
                }
            })
            .catch(() => {
                // error in save
                nameField &&
                    setError(nameField, {
                        type: 'manual',
                        message:
                            type === 0
                                ? EQuestion.message.error.inputSave
                                : EQuestion.message.error.selectSave,
                    });
            });
    };

    const triggerSave = (
        e: any,
        idQuestion: string,
        type: number,
        nameField: string = '',
        nameParent?: string,
        ind?: number
    ) => {
        if (type === 0 || type === 5) {
            // input
            const val = e.target.value;
            const question = {
                idpregunta: idQuestion,
                respuestatexto: val || '',
            };
            saveQuestion(question, nameField, type);
        } else if (type === 1) {
            // select
            const val = e;
            const { value = '', label = '' } = val;
            const question = {
                idpregunta: idQuestion,
                respuestatexto: [
                    {
                        idpregunta: value,
                        respuestatexto: label,
                    },
                ],
            };
            saveQuestion(question, nameField, type);
        } else if (type === 2) {
            // select multi
            const val = e;
            const answers = val.map((item: IMenuItem) => ({
                idpregunta: item.value || '',
                respuestatexto: item.label || '',
            }));

            const question = {
                idpregunta: idQuestion,
                respuestatexto: answers,
            };
            saveQuestion(question, nameField, type);
        } else if (type === 6) {
            // select nested
            const val = e;
            const { value = '', label = '' } = val;

            let arrTemp: any = [];
            const fieldByIdParentChild = document.getElementById(nameField);
            const fields = document.querySelectorAll('.' + nameParent);
            fieldByIdParentChild?.setAttribute('value-idpregunta', value);
            fieldByIdParentChild?.setAttribute('value-respuestatexto', label);
            fields &&
                fields.forEach((field) => {
                    const vi = field?.getAttribute('value-idpregunta') || '';
                    const vr =
                        field?.getAttribute('value-respuestatexto') || '';
                    if (vi && vr) {
                        arrTemp.push({
                            idpregunta: vi,
                            respuestatexto: vr,
                        });
                    } else {
                        arrTemp.push(null);
                    }
                    return field;
                });
            const question: IFormatQuestion = {
                idpregunta: idQuestion,
                respuestatexto: arrTemp,
            };

            saveQuestion(question, nameField, type);
        }
    };

    const createDefaultSelect = (q: any, isNested = false, ind: number = 0) => {
        const { tipopregunta } = q || {};
        let temp = null;

        if (tipopregunta === 1) {
            temp = {
                label: q?.respuesta?.respuestatexto[0].respuestatexto || '',
                value: q?.respuesta?.respuestatexto[0].idpregunta || '',
            };
        } else if (tipopregunta === 2) {
            temp = (q?.respuesta?.respuestatexto || []).map((item: any) => ({
                label: item.respuestatexto || '',
                value: item.idpregunta || '',
            }));
        } else if (tipopregunta === 6 && isNested) {
            temp = (q?.respuesta?.respuestatexto || []).map((item: any) => ({
                label: item?.respuestatexto || '',
                value: item?.idpregunta || '',
            }));

            temp = temp[ind] ? temp[ind] : [];
        }

        return temp;
    };

    const createOptions = (opts: any = []): IMenuItem[] => {
        let temp: IMenuItem[] = opts.map((o: any) => ({
            value: o.idopcion,
            label: o.descripcion,
        }));

        return temp;
    };

    const createOptionsFromJson = (opts: any): IMenuItem[] => {
        let temp: IMenuItem[] = [];
        if (opts) {
            for (const [key, value] of Object.entries(opts)) {
                temp.push({
                    value: key,
                    label: value as string,
                });
            }
        }

        return temp;
    };

    const handleDeclaration = () => {
        const urlFile = '/pdf/Declaracion_Jurada-IPAE.pdf';
        const link = document.createElement('a');
        link.href = urlFile;
        link.setAttribute('download', 'Declaracion_Jurada-IPAE.pdf');
        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);
    };

    const details = [
        'Esta información es sobre la empresa, no específicamente de la iniciativa',
        'El concepto de Valor Compartido incluye, necesariamente, que exista impacto en la sociedad, impacto económico en el negocio y un elemento de innovación, que permita que ambos impactos crezcan en el tiempo.',
        'El concepto de Valor Compartido incluye, necesariamente, que exista impacto en la sociedad, impacto económico en el negocio y un elemento de innovación, que permita que ambos impactos crezcan en el tiempo.',
        '',
    ];

    return (
        <>
            {questions.map((q: any, idx: number) => (
                <div key={'idC' + q?.idcategoria}>
                    {selectedMenu?.value?.toString() === (idx + 1).toString() &&
                    details[idx] ? (
                        <div
                            className={classnames({
                                WizardSectionDetail: true,
                            })}
                        >
                            {details[idx]}
                        </div>
                    ) : (
                        ''
                    )}
                    {q?.secciones?.length > 0 &&
                        q?.secciones.map((s: any) => (
                            <div
                                key={
                                    'idS' + s?.idseccion + '-' + q?.idcategoria
                                }
                                className={classnames({
                                    WizardSection: true,
                                    Hide:
                                        selectedMenu?.value?.toString() !==
                                        q?.idcategoria?.toString(),
                                })}
                            >
                                <h5 className="WizardTitle">
                                    {s?.descripcion}
                                </h5>
                                {s?.preguntas?.length > 0 &&
                                    s?.preguntas.map((qI: any) => (
                                        <div
                                            className="mb1"
                                            key={
                                                'idQI' +
                                                q?.idcategoria +
                                                '-' +
                                                s?.idseccion +
                                                '-' +
                                                qI?.idpregunta
                                            }
                                        >
                                            {qI?.tipopregunta === 0 ||
                                            qI?.tipopregunta === 5 ? (
                                                // Input = 0, TextArea = 5
                                                <>
                                                    <label
                                                        className={classnames({
                                                            label: true,
                                                            invalid:
                                                                errors[
                                                                    createName(
                                                                        qI?.idpregunta,
                                                                        s?.idseccion
                                                                    )
                                                                ],
                                                        })}
                                                        htmlFor={createName(
                                                            qI?.idpregunta,
                                                            s?.idseccion
                                                        )}
                                                    >
                                                        {qI?.descripcion}
                                                        {qI?.textosugerencia &&
                                                        qI.textosugerencia.trim() ? (
                                                            <>
                                                                <img
                                                                    className="infoIcon"
                                                                    data-tip={
                                                                        qI.textosugerencia
                                                                    }
                                                                    data-html={
                                                                        true
                                                                    }
                                                                    data-effect="solid"
                                                                    data-class="infoIconCustom"
                                                                    data-arrow-color="#4959b1"
                                                                    src={
                                                                        IconInfo
                                                                    }
                                                                    alt=""
                                                                />
                                                                <ReactTooltip />
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </label>
                                                    {qI?.tipopregunta === 0 ? (
                                                        <>
                                                            <input
                                                                defaultValue={
                                                                    qI?.respuesta?.respuestatexto.trim() ||
                                                                    ''
                                                                }
                                                                className={classnames(
                                                                    {
                                                                        input: true,
                                                                        invalid:
                                                                            errors[
                                                                                createName(
                                                                                    qI?.idpregunta,
                                                                                    s?.idseccion
                                                                                )
                                                                            ],
                                                                    }
                                                                )}
                                                                id={createName(
                                                                    qI?.idpregunta,
                                                                    s?.idseccion
                                                                )}
                                                                maxLength={
                                                                    EQuestion.maxLength
                                                                }
                                                                {...register(
                                                                    createName(
                                                                        qI?.idpregunta,
                                                                        s?.idseccion
                                                                    ),
                                                                    {
                                                                        required:
                                                                            {
                                                                                value: false,
                                                                                message:
                                                                                    EQuestion
                                                                                        .message
                                                                                        .required,
                                                                            },
                                                                        minLength:
                                                                            {
                                                                                value: EQuestion.minLength,
                                                                                message:
                                                                                    EQuestion
                                                                                        .message
                                                                                        .minLength,
                                                                            },
                                                                        maxLength:
                                                                            {
                                                                                value:
                                                                                    qI?.longitud ||
                                                                                    EQuestion.maxLength,
                                                                                message:
                                                                                    EQuestion
                                                                                        .message
                                                                                        .maxLength,
                                                                            },
                                                                    }
                                                                )}
                                                                onBlur={(e) =>
                                                                    triggerSave(
                                                                        e,
                                                                        qI?.idpregunta,
                                                                        qI?.tipopregunta,
                                                                        createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                            <div className="count">
                                                                {
                                                                    watch(
                                                                        createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion
                                                                        )
                                                                    )?.length
                                                                }{' '}
                                                                /
                                                                {' ' +
                                                                    qI?.longitud ||
                                                                    EQuestion.maxLength}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <textarea
                                                                defaultValue={
                                                                    qI?.respuesta?.respuestatexto.trim() ||
                                                                    ''
                                                                }
                                                                className={classnames(
                                                                    {
                                                                        textarea:
                                                                            true,
                                                                        invalid:
                                                                            errors[
                                                                                createName(
                                                                                    qI?.idpregunta,
                                                                                    s?.idseccion
                                                                                )
                                                                            ],
                                                                    }
                                                                )}
                                                                id={createName(
                                                                    qI?.idpregunta,
                                                                    s?.idseccion
                                                                )}
                                                                maxLength={
                                                                    EQuestion.maxLength
                                                                }
                                                                {...register(
                                                                    createName(
                                                                        qI?.idpregunta,
                                                                        s?.idseccion
                                                                    ),
                                                                    {
                                                                        required:
                                                                            {
                                                                                value: false,
                                                                                message:
                                                                                    EQuestion
                                                                                        .message
                                                                                        .required,
                                                                            },
                                                                        minLength:
                                                                            {
                                                                                value: EQuestion.minLength,
                                                                                message:
                                                                                    EQuestion
                                                                                        .message
                                                                                        .minLength,
                                                                            },
                                                                        maxLength:
                                                                            {
                                                                                value:
                                                                                    qI?.longitud ||
                                                                                    EQuestion.maxLength,
                                                                                message:
                                                                                    EQuestion
                                                                                        .message
                                                                                        .maxLength,
                                                                            },
                                                                    }
                                                                )}
                                                                onBlur={(e) =>
                                                                    triggerSave(
                                                                        e,
                                                                        qI?.idpregunta,
                                                                        qI?.tipopregunta,
                                                                        createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                            <div className="count">
                                                                {
                                                                    watch(
                                                                        createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion
                                                                        )
                                                                    )?.length
                                                                }{' '}
                                                                /
                                                                {' ' +
                                                                    qI?.longitud ||
                                                                    EQuestion.maxLength}
                                                            </div>
                                                        </>
                                                    )}

                                                    <div className="helpText invalid">
                                                        {errors[
                                                            createName(
                                                                qI?.idpregunta,
                                                                s?.idseccion
                                                            )
                                                        ] &&
                                                            errors[
                                                                createName(
                                                                    qI?.idpregunta,
                                                                    s?.idseccion
                                                                )
                                                            ]?.message}
                                                    </div>
                                                </>
                                            ) : qI?.tipopregunta === 1 ||
                                              qI?.tipopregunta === 2 ||
                                              qI?.tipopregunta === 6 ? (
                                                // Select && Multiple
                                                <>
                                                    <label
                                                        className={classnames({
                                                            label: true,
                                                            invalid:
                                                                errors[
                                                                    createName(
                                                                        qI?.idpregunta,
                                                                        s?.idseccion
                                                                    )
                                                                ],
                                                        })}
                                                        htmlFor={createName(
                                                            qI?.idpregunta,
                                                            s?.idseccion
                                                        )}
                                                    >
                                                        {qI?.descripcion}
                                                        {qI?.textosugerencia &&
                                                        qI.textosugerencia.trim() ? (
                                                            <>
                                                                <img
                                                                    className="infoIcon"
                                                                    data-tip={
                                                                        qI.textosugerencia
                                                                    }
                                                                    data-html={
                                                                        true
                                                                    }
                                                                    data-effect="solid"
                                                                    data-class="infoIconCustom"
                                                                    data-arrow-color="#4959b1"
                                                                    src={
                                                                        IconInfo
                                                                    }
                                                                    alt=""
                                                                />
                                                                <ReactTooltip />
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </label>
                                                    {qI?.tipopregunta !== 6 && (
                                                        <>
                                                            <Select
                                                                defaultValue={createDefaultSelect(
                                                                    qI,
                                                                    false
                                                                )}
                                                                id={createName(
                                                                    qI?.idpregunta,
                                                                    s?.idseccion
                                                                )}
                                                                styles={
                                                                    selectStyles
                                                                }
                                                                theme={
                                                                    selectTheme
                                                                }
                                                                placeholder="Selecciona una opción"
                                                                options={createOptions(
                                                                    qI?.opciones
                                                                )}
                                                                isMulti={
                                                                    qI?.tipopregunta ===
                                                                    2
                                                                }
                                                                selectProps={{
                                                                    ref: register(
                                                                        createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion
                                                                        ),
                                                                        {
                                                                            required:
                                                                                {
                                                                                    value: false,
                                                                                    message:
                                                                                        EQuestion
                                                                                            .message
                                                                                            .required,
                                                                                },
                                                                        }
                                                                    ),
                                                                }}
                                                                error={Boolean(
                                                                    errors.question4
                                                                )}
                                                                onChange={(e) =>
                                                                    triggerSave(
                                                                        e,
                                                                        qI?.idpregunta,
                                                                        qI?.tipopregunta,
                                                                        createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                    {qI?.tipopregunta === 6 && (
                                                        // Select Nested
                                                        <div className="ContentNested">
                                                            {qI?.opciones?.map(
                                                                (
                                                                    opt: any,
                                                                    indOpt: number
                                                                ) => (
                                                                    <div
                                                                        key={createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion +
                                                                                '-' +
                                                                                opt?.idopcion
                                                                        )}
                                                                        id={createName(
                                                                            qI?.idpregunta,
                                                                            s?.idseccion +
                                                                                '-' +
                                                                                opt?.idopcion
                                                                        )}
                                                                        className={classnames(
                                                                            {
                                                                                SelectAnexo:
                                                                                    true,
                                                                                [createName(
                                                                                    qI?.idpregunta,
                                                                                    s?.idseccion
                                                                                )]:
                                                                                    true,
                                                                            }
                                                                        )}
                                                                        value-idpregunta={
                                                                            qI
                                                                                ?.respuesta
                                                                                ?.respuestatexto[
                                                                                indOpt
                                                                            ]
                                                                                ?.idpregunta ||
                                                                            ''
                                                                        }
                                                                        value-respuestatexto={
                                                                            qI
                                                                                ?.respuesta
                                                                                ?.respuestatexto[
                                                                                indOpt
                                                                            ]
                                                                                ?.respuestatexto ||
                                                                            ''
                                                                        }
                                                                    >
                                                                        <p
                                                                            className={classnames(
                                                                                {
                                                                                    SelectNestedYear:
                                                                                        true,
                                                                                }
                                                                            )}
                                                                        >
                                                                            {
                                                                                opt.descripcion
                                                                            }
                                                                        </p>
                                                                        <Select
                                                                            defaultValue={createDefaultSelect(
                                                                                qI,
                                                                                true,
                                                                                indOpt
                                                                            )}
                                                                            styles={
                                                                                selectStyles
                                                                            }
                                                                            theme={
                                                                                selectTheme
                                                                            }
                                                                            placeholder="Selecciona una opción"
                                                                            options={createOptionsFromJson(
                                                                                opt?.opciones
                                                                            )}
                                                                            selectProps={{
                                                                                ref: register(
                                                                                    createName(
                                                                                        qI?.idpregunta,
                                                                                        s?.idseccion +
                                                                                            '-' +
                                                                                            opt?.idopcion
                                                                                    ),
                                                                                    {
                                                                                        required:
                                                                                            {
                                                                                                value: false,
                                                                                                message:
                                                                                                    EQuestion
                                                                                                        .message
                                                                                                        .required,
                                                                                            },
                                                                                    }
                                                                                ),
                                                                            }}
                                                                            error={Boolean(
                                                                                errors.question4
                                                                            )}
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                triggerSave(
                                                                                    e,
                                                                                    qI?.idpregunta,
                                                                                    qI?.tipopregunta,
                                                                                    createName(
                                                                                        qI?.idpregunta,
                                                                                        s?.idseccion +
                                                                                            '-' +
                                                                                            opt?.idopcion
                                                                                    ),
                                                                                    createName(
                                                                                        qI?.idpregunta,
                                                                                        s?.idseccion
                                                                                    ),
                                                                                    indOpt
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    )}

                                                    <div className="helpText invalid">
                                                        {errors[
                                                            createName(
                                                                qI?.idpregunta,
                                                                s?.idseccion
                                                            )
                                                        ] &&
                                                            errors[
                                                                createName(
                                                                    qI?.idpregunta,
                                                                    s?.idseccion
                                                                )
                                                            ]?.message}
                                                    </div>
                                                </>
                                            ) : qI?.tipopregunta === 3 ? (
                                                // Video
                                                <div className="WizardSection">
                                                    <div className="mb1 row">
                                                        <div className="col-3">
                                                            <label className="label">
                                                                {
                                                                    qI?.descripcion
                                                                }
                                                            </label>
                                                        </div>
                                                        <div className="col">
                                                            <Upload type="video"></Upload>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : qI?.tipopregunta === 4 ? (
                                                // Documento
                                                <div className="WizardSection">
                                                    <h5 className="WizardTitle">
                                                        Declaración jurada
                                                    </h5>
                                                    <div className="mb1">
                                                        <label className="label">
                                                            {qI?.descripcion}
                                                        </label>
                                                        <div className="mb1">
                                                            <button
                                                                type="button"
                                                                className="button buttonLink"
                                                                onClick={
                                                                    handleDeclaration
                                                                }
                                                            >
                                                                <img
                                                                    className="buttonIconLeft"
                                                                    src={
                                                                        IconDownload
                                                                    }
                                                                    alt=""
                                                                />
                                                                Descargar
                                                                declaración
                                                                jurada aquí
                                                            </button>
                                                        </div>
                                                        <Upload type="doc"></Upload>
                                                    </div>
                                                </div>
                                            ) : (
                                                ''
                                                // Tipo de pregunta diferente a: 0, 1, 2, 3, 4
                                            )}
                                        </div>
                                    ))}
                            </div>
                        ))}
                </div>
            ))}
        </>
    );
};

export default Wizard;
